/* Block types used by the Course Module Builder & the Doc Template Builder.
 *
 * A block is a small JSON object, e.g.
 *   { type: "heading", level: 2, text: "Introduction", align: "left" }
 *   { type: "video", provider: "youtube", url: "https://youtu.be/XXX", caption: "..." }
 *
 * Renderers are intentionally permissive: unknown props are ignored so data
 * stays future-proof.
 */

export const BLOCK_TEMPLATES = [
  { type: "heading", level: 2, text: "Nouveau titre", align: "left" },
  { type: "paragraph", text: "Saisissez votre contenu ici. Utilisez {{eleve.nom}} pour inserer une balise.", align: "left" },
  { type: "image", url: "", caption: "", align: "center" },
  { type: "video", provider: "youtube", url: "", caption: "" },
  { type: "embed", url: "", caption: "" },
  { type: "list", items: ["Element 1", "Element 2"], ordered: false },
  { type: "quote", text: "Citation inspirante", author: "" },
  { type: "callout", kind: "info", text: "Information importante" },
  { type: "divider" },
  { type: "spacer", size: 20 },
  { type: "columns", cols: [[], []], ratio: "1-1" },
];

export function makeBlock(type, overrides) {
  const tpl = BLOCK_TEMPLATES.find((b) => b.type === type);
  const base = JSON.parse(JSON.stringify(tpl || { type: "paragraph", text: "" }));
  return overrides ? { ...base, ...overrides } : base;
}

export const THEMES = {
  blitzz: {
    label: "Blitzz (jaune/noir)",
    bg: "#0b0811",
    text: "#e8e6ec",
    accent: "#f7c935",
    muted: "#8a8497",
    heading: "#ffffff",
    code: "#1a1622",
  },
  light: {
    label: "Clair (papier)",
    bg: "#ffffff",
    text: "#1a1a1a",
    accent: "#2563eb",
    muted: "#6b7280",
    heading: "#111111",
    code: "#f4f4f5",
  },
  ocean: {
    label: "Ocean",
    bg: "#061826",
    text: "#cde3f3",
    accent: "#38bdf8",
    muted: "#7aa2c0",
    heading: "#ffffff",
    code: "#0a2c44",
  },
  forest: {
    label: "Forest",
    bg: "#0a1a13",
    text: "#d5ead9",
    accent: "#34d399",
    muted: "#8aa798",
    heading: "#ffffff",
    code: "#0f2a1e",
  },
};
